import React from 'react';
import { Card, CardContent, Box, Typography, Chip } from '@mui/material';

interface Props {
  thread: {
    threadId: string;
    subject: string;
    status: string;
    companyName?: string;
    athleteUuid?: string;
    contactShared?: boolean;
    lastMessage?: string;
    createdAt: string;
    updatedAt: string;
  };
  onClick: () => void;
  role: 'athlete' | 'company';
}

const statusLabels: Record<string, { label: string; color: 'default' | 'primary' | 'success' | 'error' | 'warning' }> = {
  pending: { label: '未読', color: 'warning' },
  read: { label: '既読', color: 'primary' },
  accepted: { label: '承諾', color: 'success' },
  declined: { label: '辞退', color: 'error' },
  blocked: { label: 'ブロック', color: 'error' },
};

const ScoutCard: React.FC<Props> = ({ thread, onClick, role }) => {
  const status = statusLabels[thread.status] || { label: thread.status, color: 'default' as const };

  return (
    <Card
      sx={{
        cursor: 'pointer',
        '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.1)' },
        borderLeft: thread.status === 'pending' ? '4px solid #ff9800' : 'none',
      }}
      onClick={onClick}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            {thread.subject}
          </Typography>
          <Box sx={{ display: 'flex', gap: 0.5 }}>
            <Chip label={status.label} size="small" color={status.color} />
            {thread.contactShared && (
              <Chip label="連絡先共有済" size="small" color="info" />
            )}
          </Box>
        </Box>
        <Typography variant="body2" sx={{ color: '#666', mb: 1 }}>
          {role === 'athlete' ? thread.companyName : `アスリート (${thread.athleteUuid?.slice(0, 8)}...)`}
        </Typography>
        {thread.lastMessage && (
          <Typography variant="body2" sx={{ color: '#999', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {thread.lastMessage}
          </Typography>
        )}
        <Typography variant="caption" sx={{ color: '#999', mt: 1, display: 'block' }}>
          {new Date(thread.updatedAt).toLocaleDateString('ja-JP')}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ScoutCard;
